<template>
	<div>
		<div class="uk-margin-large-bottom">
			<nav class="uk-navbar-container" uk-navbar>
				<div class="uk-navbar-left">
					<h1 class="uk-navbar-item uk-logo">スタッフログイン</h1>
				</div>
			</nav>
		</div>
		<div class="uk-container">
			<div id="login_form" class="uk-form-horizontal">
				<div class="uk-margin">
					<label class="uk-form-label" for="form_horizontal_staff_number">社員番号 (必須)</label>
					<div class="uk-form-controls">
						<input class="uk-input" id="form_horizontal_staff_number" name="staff_number" type="text" placeholder="社員番号を入力してください">
						<p class="uk-alert-danger uk-padding-small" v-if="this.isLoginError">社員番号またはパスワードが間違っています。</p>
					</div>
				</div>
				<div class="uk-margin">
					<label class="uk-form-label" for="form_horizontal_password">パスワード (必須)</label>
					<div class="uk-form-controls">
						<input class="uk-input" id="form_horizontal_password" name="password" type="password" placeholder="パスワードを入力してください">
						<p class="uk-alert-danger uk-padding-small" v-if="this.isLoginError">社員番号またはパスワードが間違っています。</p>
					</div>
				</div>
				<div class="uk-margin">
					<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" @click="onClickSubmit">ログイン</button>
				</div>
			</div>
		</div>
		<div class="uk-container uk-margin-large">
			<p class="uk-text-small uk-align-right">v{{APP_VERSION}}</p>
		</div>
	</div>
</template>

<script>
	import Role from '@/api/Role'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import StaffAuth from '@/api/StaffAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'

	export default {
		name: 'StaffLoginPage',
		data () {
			return {
				isLoginError: false
			}
		},
		computed: {
			APP_VERSION () {
				return APP_VERSION
			}
		},
		methods: {
			onClickSubmit () {
				let self = this

				let staff_number = $('[name="staff_number"]').val()
				let password = $('[name="password"]').val()

				let params = new URLSearchParams()
				params.append('staff_number', staff_number)
				params.append('password', password)

				StaffAuth.login(params).then(function (response) { // ログイン処理
					let data = response.data

					if (data.data == false) { // 失敗
						self.isLoginError = true
					} else { // 成功
						StaffAuth.current().then(function (response) {
							let current_staff = response.data.data

							// CallCenterAuth.logout().then(function (response) {
								// BranchOfficeAuth.logout().then(function (responase) {
									// MainOfficeAuth.logout().then(function (response) {
										document.title = '予約管理ツール【スタッフ】'
										self.$router.push('/reservation_list/' + current_staff.shop_id)
										// location.reload()
									// })
								// })
							// })
						})
					}
				})
			}
		},
		mounted () {
			Role.show().then()
			StaffAuth.current().then()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/auth/StaffLoginPage.vue